export default __webpack_public_path__ + "static/media/C.bd953808.png";